import { Base64 } from "js-base64";
import Crypto from "crypto-js";
import { getSignatureKey } from "../services/tvodService";

export function base64Encode(encodedString) {
  const decodedString = Base64.encode(encodedString);
  return decodedString;
}

function generateSignatureMessage(requestBody = {}) {
  return Object.keys(requestBody)
    .map(key => key + "=" + requestBody[key])
    .join("&");
}

export function generateSignatureSHA512(requestBody) {
  const message = generateSignatureMessage(requestBody);
  // const hash = Crypto.SHA256(message, getSignatureKey());
  const hash512 = Crypto.HmacSHA512(message, getSignatureKey());
  // console.log("Crypto.enc.Hex.stringify(hash) ==>", Crypto.enc.Hex.stringify(hash));
  // console.log("Crypto.enc.Hex.stringify(hash512) ==>", Crypto.enc.Hex.stringify(hash512));
  return Crypto.enc.Hex.stringify(hash512);
}
